<script>
    import { createEventDispatcher } from "svelte";

  export let open = false;
  export let title = 'Are you sure?';
  export let desc = `Mauris non nibh vel nisi sollicitudin malesuada. 
      Donec ut sagittis erat. Praesent eu eros felis. 
      Ut consectetur placerat pulvinar.`;
  export let cancelText = 'Cancel';
  export let confirmText = 'Confirm';

  const dispatch = createEventDispatcher();

  function cancel() {
    dispatch('cancel');
  }
  function confirm() {
    dispatch('confirm');
  }
</script>

<dialog {open}>
  <article>
    <h3>{title}</h3>
    <slot>
      <p>
        {desc}
      </p>
    </slot>
    <footer>
      {#if cancelText}
      <a href="#cancel" on:click|preventDefault={cancel} role="button" class="secondary">{cancelText}</a>
      {/if}
      {#if confirmText}
      <a href="#confirm" on:click|preventDefault={confirm} role="button">{confirmText}</a>
      {/if}
    </footer>
  </article>
</dialog>
